import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, makeStyles, Paper, Snackbar, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'

import { getHasRequestError, getHasRequestPending } from '../../../redux/data/selectors'
import Loader from '../../../common/components/notifications/Loader'
import actions from '../../../redux/actions'
import { GET_USERS, REMOVE_CONTENT_GROUP_USER } from '../../../redux/data/types'
import config from '../../../config'
import AddUsersDialog from './AddUsersDialog'
import { Alert } from '@material-ui/lab'
import RestrictedComponent from '../../../lib/components/form/RestrictedComponent'
import schema from '../../../routes/permissions/schema'

const useStyles = makeStyles(theme => ({
  emptyContainer: {
    margin: '1rem',
    padding: '1rem',
    backgroundColor: 'rgb(230,230,230)'
  },
  addButton: {
    margin: '1rem',
    marginBottom: 0
  }
}))

const NoGroupUsers = () => {
  const classes = useStyles()
  return <Paper className={classes.emptyContainer}>
    No Users Assigned to Group
  </Paper>
}

const GroupUsers = props => {
  const {
    contentGroup,
    onAssign,
    onRemove,
    usersLoaded,
    usersPending,
    users,
    requestUsers,
    removeRequestError,
    removeRequestPending
  } = props

  const [showAddUsersDialog, setShowAddUsersDialog] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [showSnackbar, setShowSnackbar] = useState(false)

  const classes = useStyles()

  let snackMessage = removeRequestPending ? 'Removing User' : 'User Removed'
  if (removeRequestError) {
    snackMessage = 'Error: ' + removeRequestError
  }

  const handleCloseSnackbar = () => setShowSnackbar(false)

  useEffect(() => {
    if (removeRequestPending || removeRequestError) {
      setShowSnackbar(true)
    }
  }, [removeRequestPending, removeRequestError])


  useEffect(() => {
    if (!usersPending && !usersLoaded) {
      requestUsers()
    }
  }, [usersPending, usersLoaded])

  if (usersPending || !usersLoaded) {
    return <Loader />
  }

  const handleAddUsers = addedUsers => {
    onAssign(addedUsers)
    setShowAddUsersDialog(false)
  }
  return <div>
    <Snackbar open={showSnackbar} autoHideDuration={9000} onClose={handleCloseSnackbar}>
      <Alert onClose={handleCloseSnackbar} severity={removeRequestError ? 'error' : removeRequestPending ? 'info' : 'success'}>
        {snackMessage}
      </Alert>
    </Snackbar>
    <RestrictedComponent permissionCheck={schema.ACCOUNT_CONTENT_GROUPS.UPDATE}>
      <Button
        className={classes.addButton}
        onClick={() => setShowAddUsersDialog(true)}
        variant="contained"
        color="primary"
        size="large"
      >
        Add Users
      </Button>
    </RestrictedComponent>
    <hr />
    {contentGroup.GroupUsers.length ? <Table>
      <TableHead>
        <TableRow>
          <TableCell>
            Assigned Users
        </TableCell>
          <TableCell padding="checkbox" />
        </TableRow>
      </TableHead>
      <TableBody>
        {contentGroup.GroupUsers.map((user, i) => {
          return <TableRow key={'user row:' + i}>
            <TableCell>
              <div>
                <div>{user.firstName} {user.lastName}</div>
                <div>{user.email}</div>
              </div>
            </TableCell>
            <TableCell padding="checkbox">
              <RestrictedComponent permissionCheck={schema.ACCOUNT_SECURITY_GROUPS.UPDATE}>
                <IconButton onClick={() => setConfirmDelete(user)}>
                  <DeleteIcon color="secondary" />
                </IconButton>
              </RestrictedComponent>
            </TableCell>
          </TableRow>
        })}
      </TableBody>
    </Table> : <NoGroupUsers />}
    <Dialog open={!!confirmDelete} onClose={() => setConfirmDelete(false)}>
      <DialogTitle>Remove User From Group?</DialogTitle>
      <DialogContent>
        Are you sure you want to remove {confirmDelete.firstName + " " + confirmDelete.lastName} from the group {contentGroup.Group.groupName}?
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setConfirmDelete(false)}
          variant="contained"
          color="secondary"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            setConfirmDelete(false)
            onRemove(confirmDelete)
          }}
          variant="contained"
          color="primary"
        >
          Remove From Group
        </Button>
      </DialogActions>
    </Dialog>
    <AddUsersDialog
      isOpen={showAddUsersDialog}
      users={users}
      onAdd={users => handleAddUsers(users)}
      onRemove={onRemove}
      onClose={() => setShowAddUsersDialog(false)}
      groupUsers={contentGroup.GroupUsers}
      groupID={contentGroup.Group.groupID}
    />
  </div>
}

const mapStateToProps = (state, ownProps) => {
  const users = state.data.users
  const usersRequests = [GET_USERS]

  const usersLoaded = usersRequests.some(type => state.request[type] && state.request[type].pending === false)
  const usersPending = usersRequests.some(type => getHasRequestPending(state, type))
  const clientID = state.data.user.clientId

  const removeRequestPending = getHasRequestPending(state, REMOVE_CONTENT_GROUP_USER)
  const removeRequestError = getHasRequestError(state, REMOVE_CONTENT_GROUP_USER)

  return { usersLoaded, usersPending, users, clientID, removeRequestPending, removeRequestError }
}

const mapDispatchToProps = dispatch => ({
  callDispatch: func => dispatch(func),
})

const mergeProps = (stateProps, _dispatchProps, ownProps) => {
  const dispatch = func => _dispatchProps.callDispatch(func)
  const requestUsers = () => dispatch(actions.request.sendRequest({
    type: GET_USERS,
    url: `${config.uris.crud}Users/getUsers`,
    postData: {
      clientID: stateProps.clientID
    }
  }))
  return { requestUsers, ...stateProps, ...ownProps }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(GroupUsers)
